// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25D_2","content":"styles_content__1o6cL","row":"styles_row__1Tm5u","footer":"styles_footer__-9afI","phraseLength":"styles_phraseLength__13IYn"};